// Centralized, single source of truth for annotation types and labels

export const ANNOTATION_TYPES = [
  'task',
  'alarm',
  'diagnostic_rule',
  'note',
  'machine_condition_change',
  'repair'
];

export const TYPE_LABEL = {
  task: 'Tasks',
  alarm: 'Alarms',
  diagnostic_rule: 'Diagnostics',
  note: 'Notes',
  machine_condition_change: 'Condition',
  repair: 'Repairs'
};

// Entity scopes the annotations API will actually serve.
//
// GET /api/v1/annotations validates `annotatable_type` against a 'tag'-only
// allowlist (cloud: app/controllers/v1/annotations/schemas.py,
// GetAnnotationsSchema). Any other scope is rejected with
// 400 "annotatable_type: Invalid value", which the load action surfaces as an
// error toast -- so a machine-scoped chart (e.g. the health timeline widget)
// would pop that toast on every visit while annotations are switched on.
// Callers must check before dispatching a load. Widen this only together with
// the backend schema.
export const SUPPORTED_ANNOTATABLE_TYPES = ['tag'];

export const isSupportedAnnotatableType = type => SUPPORTED_ANNOTATABLE_TYPES.indexOf(type) !== -1;

// i18n keys for annotation type labels (used by AnnotationControls, tooltips, etc.)
export const TYPE_LABEL_I18N_KEY = {
  task: 'annotations.types.task',
  alarm: 'annotations.types.alarm',
  diagnostic_rule: 'annotations.types.diagnostic_rule',
  note: 'annotations.types.note',
  machine_condition_change: 'annotations.types.machine_condition_change',
  repair: 'annotations.types.repair'
};
